import Skeleton from "components/Skeleton";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { calculateReadingTime, countWordsFromHTML } from "utils";

const BlogCard = ({ post, recent = false, category }) => {
  const { labels, title, id, published, content } = post;
  const elementRef = useRef();
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [wordCount, setWordCount] = useState(0);

  const TITLE_LENGTH = 120;

  useEffect(() => {
    if (!content) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    // Get first image
    const img = doc.querySelector("img");

    if (img?.src) {
      setImage(img.src);
    }

    // Get text
    const text = doc.body.textContent || "";
    setDescription(text.trim());

    // Word count
    setWordCount(countWordsFromHTML(content));
  }, [content]);

  console.log({ post });
  return (
    <a href={`/blog/${id}?category=${category}`} className="block group">
      {recent ? (
        <div className="relative w-full h-full rounded-xl overflow-hidden">
          {image ? (
            <img
              src={image}
              alt={title}
              className="w-full h-[400px] object-cover"
            />
          ) : (
            <div className="w-full h-[220px] bg-gray-100" />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

          <div className="absolute bottom-0 left-0 right-0 p-5 bg-white rounded-md z-10 m-3">
            <div className="flex items-center gap-2 text-sm text-[#00000066] mb-1">
              <span>{post.author.displayName}</span>
              <span className="w-1 h-1 rounded-full bg-white/70" />
              <span>{moment(published).format("MMM D, YYYY")}</span>
            </div>

            <h3 className="text-base text-black leading-[24px] font-semibold line-clamp-2">
              {title}
            </h3>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col h-full">
          {image ? (
            <img
              src={image}
              alt={title}
              className="w-full h-[300px] object-cover"
            />
          ) : (
            <div className="w-full h-[220px] bg-gray-100" />
          )}

          <div className="p-4 flex flex-col gap-3 flex-1">
            <div className="flex items-center justify-between ">
              <div className="flex items-center gap-2 text-[12px] text-[#00000066]">
                <span>{post.author.displayName}</span>
                <span className="w-1 h-1 rounded-full bg-[#00000066]" />
                <span>{moment(published).format("MMM D, YYYY")}</span>
              </div>
              <div className="mt-auto flex items-center justify-between">
                {wordCount ? (
                  <p className="text-[12px] text-[#667085]">
                    {calculateReadingTime(wordCount)}
                  </p>
                ) : (
                  <span />
                )}
              </div>
            </div>

            <h3 className="text-[17px] leading-[24px] font-semibold text-[#101828] line-clamp-2">
              {title}
            </h3>

            <p className="text-[14px] leading-[22px] text-[#00000066] line-clamp-3">
              {description.substring(0, 120)}
              {description.length > 120 && "..."}
            </p>

            {/* Hidden Parser */}
            <div
              dangerouslySetInnerHTML={{ __html: content }}
              ref={elementRef}
              className="hidden"
            />
          </div>
        </div>
      )}
    </a>
  );
};

export const PostSkeleton = ({ recent }) => {
  return (
    <div className={`w-full pt-8 z-[100] ${recent ? "md:flex gap-4" : ""}`}>
      <Skeleton
        styles={`w-full flex-1 h-[250px] rounded-xl  ${recent ? "md:!min-w-[250px] md:!h-[200px]" : ""}`}
      />
      <div className="w-full mt-4 space-y-2 md:space-y-4">
        <div className=" flex gap-2 flex-col">
          <Skeleton styles="rounded-3xl w-full h-[33px]" />
          <Skeleton styles="rounded-3xl w-full h-[33px]" />
        </div>
        <div className="flex items-center justify-start gap-2">
          <Skeleton styles="rounded-3xl w-32 h-3" />
          <Skeleton styles="rounded-full w-2.5 h-2.5" />
          <Skeleton styles="rounded-3xl w-32 h-3" />
        </div>
        <div className="flex items-center justify-start gap-2">
          <Skeleton styles="rounded-3xl w-24 h-5" />
          <Skeleton styles="rounded-3xl w-24 h-5" />
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
